export enum GoalStatus {
  OFF_TRACK = 'OFF_TRACK',
  PROGRESSING = 'PROGRESSING',
  ON_TRACK = 'ON_TRACK'
}
